import type { OrderScriptRow } from "@/features/marketplace/types/marketplace.types";

export function isPartnerPreflightNotifyRetry(
  script: Pick<
    OrderScriptRow,
    "notifyState" | "pendingNotifyStatus" | "preflightUploadId"
  >,
): boolean {
  return (
    script.notifyState === "PENDING_NOTIFY" &&
    script.pendingNotifyStatus === "SUBMITTED_FOR_FEEDBACK" &&
    Boolean(script.preflightUploadId)
  );
}
